import { defineEffect } from '../../../core/effect';

/**
 * **デッキのシャッフル**（Issue #538）。
 *
 * 開く: `shuffle_deck`。デッキの位置で短く光る。
 */
const COLOR = '#a8b4d0';

export default defineEffect({
  situation: 'shuffle_deck',
  label: 'デッキのシャッフル',
  color: COLOR,

  layers: [
    {
      id: 'swirl',
      label: '渦',
      part: 'ring',
      at: { zone: 'maindeck:{player}', else: { screen: [960, 900] } },
      props: { color: COLOR, ticks: 3, width: 4 },
      tf: {
        scale: { keys: [{ ms: 0, value: 0.6 }, { ms: 320, value: 1.4, ease: 'ease_out' }] },
        opacity: { keys: [{ ms: 0, value: 0 }, { ms: 120, value: 0.8 }, { ms: 460, value: 0 }] },
        rotation: { keys: [{ ms: 0, value: 0 }, { ms: 460, value: 200 }] },
      },
    },
  ],
}, 'shuffle_deck_effect.js');
